import { Component, OnInit ,Input, Output, EventEmitter,AfterViewInit} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment'; 
import { EncryptDecryptService } from   '../../service/encrypt-decrypt.service'
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { CustomServiceService } from '../../service/custom-service.service';

import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-news-list',
  templateUrl: './news-list.component.html',
  styleUrls: ['./news-list.component.css']
})
export class NewsListComponent implements OnInit, AfterViewInit {

  constructor(private fciwebservice: fciWebsiteService, private routerparam: ActivatedRoute,private encDec:EncryptDecryptService, private route: Router,private httpservice: CustomServiceService) { }
  imageUrl = environment.serviceURL + 'storage/app/uploads/';
  backendUrl = environment.serviceURL
  newsList: any[] = [];
  archieveId:any;
  newsTitle :any;
  
  plugin_menu_dtl:any;
  employee_con:any="";
  issearch:any;
  language: any = '';

  CURRENT_ZONE_ID:any = environment.ZONE_ID;
  CURRENT_REGION_ID:any = environment.REGION_ID;
  CURRENT_ZONE_CODE:any = environment.ZONE_CODE;
  CURRENT_REGION_CODE:any = environment.REGION_CODE;
  datetime:any = this.httpservice.currentDateTime();
  
  ngOnInit(): void {

    this.language = sessionStorage.getItem('locale'); //dynamic content language translation 


    if(environment.ZONE_ID > 0){
      this.getNewsList('','','',environment.ZONE_ID,'',this.start,this.limit,this.currentPage);
        this.GetAllZoneById(environment.ZONE_ID);
        this.GetRegion(environment.ZONE_ID);
     } else {
      this.getNewsList('','','','','',this.start,this.limit,this.currentPage);
      this.ZoneList();
     }

    this.start=(this.currentPage - 1)*this.limit;
  
    this.employee_con = this.routerparam.snapshot.queryParamMap.get('emp');
    if(this.employee_con==null){
      this.plugin_menu_dtl = window.sessionStorage.getItem(btoa(this.CurrentRouteFn()));
      this.getPluginPageDetials(this.plugin_menu_dtl);
    } else {
      this.getEmployeeCornerDtl(this.encDec.decText(this.employee_con));
    }
  }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }
 
  content_apiresponse:any;
  mediaResponse :any;
  start:number=0;
  limit:number=10;
  currentPage:number = 1;
  totalRecords:number=0;
  Ltype:any;
  isdisplay: boolean = false;
  searchForm = new FormGroup({
    title: new FormControl(''),
    from_date: new FormControl(''),
    to_date: new FormControl(''),
    zone: new FormControl(''),
    region: new FormControl('')

  })
  RefreshBtn:boolean=false;
  RefreshPage(){
    this.start=0;
    this.limit=10;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.getNewsList('','','',environment.ZONE_ID,'',this.start,this.limit,this.currentPage);
    this.RefreshBtn = false;
    this.searchForm.reset();
    
   
  }
  GetAllZoneById(zoneid:any) { 
    this.zoneList = [];
    this.regionList = [];
    this.httpservice.GetAllZoneById({'zone_id':zoneid}).subscribe((response: HttpEvent<any>) => { 
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.list;
          } 
      }
    });
  }
  
  searchNewsList(){
    let param_arr = []; 
    this.isdisplay = true;
    let title,from_date,to_date,zone,region;
    title="";
    from_date="";
    to_date="";
    zone="";
    region="";
    if(this.searchForm.value.title!==""){
      if(this.searchForm.value.title!==null){
        param_arr.push(this.searchForm.value.title);
        title = this.searchForm.value.title;
      }
    }
    if(this.searchForm.value.from_date!==""){
      if(this.searchForm.value.from_date!==null){
        param_arr.push(this.searchForm.value.from_date);
        from_date = this.searchForm.value.from_date;
      }
    }
    if(this.searchForm.value.to_date!==""){
      if(this.searchForm.value.to_date!==null){
        param_arr.push(this.searchForm.value.to_date);
        to_date = this.searchForm.value.to_date;
      }
    }
    if(this.searchForm.value.zone!==""){
      if(this.searchForm.value.zone!==null){
        param_arr.push(this.searchForm.value.zone);
        zone = this.searchForm.value.zone;
      }
    }
    if(this.searchForm.value.region!==""){
      if(this.searchForm.value.region!==null){
        param_arr.push(this.searchForm.value.region);
        region = this.searchForm.value.region;
      }
    }
    
    if(param_arr.length <= 0){
     
      Swal.fire({
        icon: 'warning',
        text: (this.language=='English') ? "Please select at least one parameter" : "कृपया कम से कम एक पैरामीटर चुनें",
      });
      return;
    }
    this.RefreshBtn=true;
    this.start=0;
    this.limit=10;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.getNewsList(title,from_date,to_date,zone,region,this.start,this.limit,this.currentPage);
  }
  get title() {
    return this.searchForm.get('title');
  }
  get from_date() {
    return this.searchForm.get('from_date');
  }
  get to_date() {
    return this.searchForm.get('to_date');
  }
  get zone() {
    return this.searchForm.get('zone');
  }
  get region() {
    return this.searchForm.get('region');
  }
  ifdisabled:boolean=false;
  btncontent:any = `Search`;
  NewsLength:any;
  getNewsList(title:any,from_date:any,to_date:any,zone:any,region:any,start:number,limit:number,currentPage:number) {

    var query:any=[];
      query = [
        {"columnName":"VCHPUBLISH_DATE","operator":"<=","value":this.datetime.date,"joinoperator":"and"},
        { "columnName": "VCHMEDIA_TYPE", "operator": "=", "value": 3, "joinoperator": "and" },
        { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
        { "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
        {"columnName":  "VCHACH_DATE","operator":">","value":new Date(),"joinoperator":"and" }
    ]; 
    let params = [

      {
        "secSlNo": 1,
        "offSet": start,
        "noOfRecords":limit,
        "orderBy": [{ "columnName": "VCHPUBLISH_DATE", "type": "DESC" }],
        "condition": query,
        "viewParameters": ""
      }];
    
    if(title!==""){
        query.push({ "columnName": "VCHTITLE", "operator": "LIKE", "value": `%${title}%`, "joinoperator": "and" });
      }

      if(zone!==""){
        if(zone!==null){
          query.push({ "columnName": "ZONE_ID", "operator": "=", "value": zone, "joinoperator": "and" });
        }
      }
      if(region!==""){
        if(region!==null){
          query.push({ "columnName": "REGION_ID", "operator": "=", "value": region, "joinoperator": "and" });
        }
      }
    if(from_date!=="" && to_date==''){
      query.push({ "columnName": "VCHPUBLISH_DATE", "operator": ">=", "value": from_date, "joinoperator": "and" });
    } else if(from_date=="" && to_date!==''){
      query.push({ "columnName": "VCHPUBLISH_DATE", "operator": "<=", "value": to_date, "joinoperator": "and" });
    } else if(from_date!=="" && to_date!==''){
      query.push({ "columnName": "VCHPUBLISH_DATE", "operator": ">=", "value": from_date, "joinoperator": "and" });
      query.push({ "columnName": "VCHPUBLISH_DATE", "operator": "<=", "value": to_date, "joinoperator": "and" });
    } 
    this.fciwebservice.getAllMediaType(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.mediaResponse = response.result.sec_1;
           
            this.NewsLength = this.mediaResponse.length
            this.newsList = this.mediaResponse;
            if(response.result.sec_1.length > 0){
              this.totalRecords = response.result.sec_1[0].noOfRec;
              this.issearch = true;
              
            } else {
              this.totalRecords = 0;
              this.issearch = false;
            }
          } 
          this.ifdisabled = false;
          this.btncontent = `Search`;
        
      }
    });
  }

  htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }
  viewDetails(id: any){
    let encSchemeStr = this.encDec.encText(id.toString());
    this.route.navigate(['./news/', encSchemeStr]);
  }
  pageChanged(page: any) {

    let param_arr = []; 
    let title,from_date,to_date,zone,region;
    title="";
    from_date="";
    to_date="";
    zone="";
    region="";
 
    if(this.searchForm.value.title!==""){
      if(this.searchForm.value.title!==null){
        param_arr.push(this.searchForm.value.title);
        title = this.searchForm.value.title;
      }
    }
    if(this.searchForm.value.from_date!==""){
      if(this.searchForm.value.from_date!==null){
        param_arr.push(this.searchForm.value.from_date);
        from_date = this.searchForm.value.from_date;
      }
    }
    if(this.searchForm.value.to_date!==""){
      if(this.searchForm.value.to_date!==null){
        param_arr.push(this.searchForm.value.to_date);
        to_date = this.searchForm.value.to_date;
      }
    }
    if(this.searchForm.value.zone!==""){
      if(this.searchForm.value.zone!==null){
        param_arr.push(this.searchForm.value.zone);
        zone = this.searchForm.value.zone;
      }
    }
    if(this.searchForm.value.region!==""){
      if(this.searchForm.value.region!==null){
        param_arr.push(this.searchForm.value.region);
        region = this.searchForm.value.region;
      }
    }
    this.currentPage=page
    this.start=(this.currentPage - 1)*this.limit;
    this.getNewsList('','','',zone,region,this.start,this.limit,this.currentPage);
  }
  showBarComponent:boolean=false;
  emp_apires:any;
  showEmpMen:boolean=false;
  p_apirespons: any;
  P_data: any;
  navMenu:boolean=false;
  navmenuloadCss = "background-color: #167a44; height: 100%;";
  showNavComponent:boolean=false;


  emp_dtl:any={'title':''};
  getEmployeeCornerDtl(id:any){
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],
        "condition": [ 
          { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
          { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
          { "columnName": "intId", "operator": "=", "value":id, "joinoperator": "and" },
        ],
        "viewParameters": ""
      }];
    this.httpservice.EmpeeloyCorner(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break; 
        case HttpEventType.Response:
        this.emp_apires = response.body;
        let respData = this.emp_apires.RESPONSE_DATA;
        let respToken = this.emp_apires.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          if(response_.result.sec_1.length > 0){
            this.emp_dtl=response_.result.sec_1[0];
            this.showBarComponent=true;
            this.showEmpMen = true;
          }
        } 
      }
    });
  }

  CurrentRouteFn:any = ():any => {
    let route_url:any = this.route.url.replace('/',"");
    route_url = route_url.split("?");
    if(route_url.length > 0){
      return route_url[0];
    }
    return route_url;
  }

  getPluginPageDetials(details:any) {
    let params;
    if(details!==null){
      let d = JSON.parse(details);
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": d.plugin_id,
        'router_link':d.selectPlugin,
        'localdata':true,
      };
    } else{
       params = {
        "zone_id": environment.ZONE_ID,
        "zone_code": environment.ZONE_CODE,
        "region_id": environment.REGION_ID,
        "region_code": environment.REGION_CODE,
        "plugin_id": false,
        'router_link':this.CurrentRouteFn(),
        'localdata':false,
      };
    }
    this.httpservice.PluginPageDetials(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
        this.p_apirespons = response.body;
        let respData = this.p_apirespons.RESPONSE_DATA;
        let respToken = this.p_apirespons.RESPONSE_TOKEN;
        let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
        if (respToken == verifyToken) { 
          let response_: any = Buffer.from(respData, 'base64');
          response_ = JSON.parse(response_);
          // console.log(response_.original);
          if(response_.original.status){
            this.P_data = response_.original;
            this.navMenu = response_.original.hasMenu;
            this.navmenuloadCss = "height: 100%;";
          } else {
            this.P_data = response_.original;//somthing wrong
          }
          this.showNavComponent=true;
          this.showBarComponent=true;
        } 
      }
    });
  }


  region_apirespons: any;
  regionList: any[] = [];
  GetRegion(val:any){
    this.regionList = [];
    let p = {'zone_id':val};
    if(val==""){
      return;
    }
    this.httpservice.GetRegionByZoneId(p).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body;
          let respData = this.region_apirespons.RESPONSE_DATA;
          let respToken = this.region_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.regionList = res.original.data;
          }
      }
    });
  }

  zone_apirespons: any;
  zoneList: any[] = [];
  ZoneList() { 
    this.httpservice.getZoneList().subscribe((response: HttpEvent<any>) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.zone_apirespons = response.body;
          let respData = this.zone_apirespons.RESPONSE_DATA;
          let respToken = this.zone_apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let res = JSON.parse(Buffer.from(respData, 'base64').toString());
            this.zoneList = res.original.data;
          } 
      }
    });
  }  
}
